import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { BsFillSendFill } from "react-icons/bs";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';

const EnterReceipt = () => {
  const location = useLocation();
  const { pay } = location.state || {};
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();

  const [payment, setPayment] = useState({
    state: "receipted",
    id: pay?.id || 0,
    receipt_no: pay?.receipt_no || "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handlePaymentChange = (field, value) => {
    setPayment((prevPayment) => ({ ...prevPayment, [field]: value }));
  };

  const handleSubmit = async () => {
    if (payment.receipt_no === '') {toast.error('Please enter the receipt number.');return;}
    setIsLoading(true);
    try {
      const response = await handleApi('purchase/payments', payment, userData, 'PUT', {});
      if (response.status === 200) {
        toast.success('Receipt successfully recorded.');
        setActionCount(actionCount + 1);
      } else {toast.error('Error entering receipt  payment.');}
    } catch (error) {toast.error('Error entering receipt : ' + error.message);
    } finally {setIsLoading(false);}
  };

  const handleClose = () => {navigate(-1);};

  return (
    <Layout>
      <div className="m-4 bg-black rounded-xl shadow-2xl p-6">
        <ToastContainer position="top-center" autoClose={2000} />
        
        <div className="text-center py-4 border-b">
                  <div className="w-full flex justify-end">
                    <button
                      className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
                      title="Close"
                      onClick={handleClose}
                    >
                      <MdOutlineCancel size={24} color={currentColor}/>
                    </button>
                  </div>
                  
                  <div className="mx-4 text-white">
                    <Header category="Purchase" title="Enter Receipt" color={currentColor}/>
                  </div>
                </div>


        

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" color="white" ariaLabel="loading" />
            <p className="mt-4 text-white">Processing payment...</p>
          </div>
        ) : (
          <div className="bg-white p-6 my-4 rounded-xl shadow-2xl">

<div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Supplier Information */}
              <div className="p-4 bg-gray-50 shadow-md rounded-lg">
                <h3 className="text-lg text-center font-bold text-gray-700 mb-3 uppercase">Supplier Info</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Supplier:</span>
                    <span>{pay?.invoice?.partners?.name || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Contact:</span>
                    <span>{pay?.invoice?.partners?.contact_person || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Phone:</span>
                    <span>{pay?.invoice?.partners?.phone_number || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Email:</span>
                    <span>{pay?.invoice?.partners?.email || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Invoice No:</span>
                    <span>{pay?.invoice?.invoice_no || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Total Amount:</span>
                    <span>{formatCurrency(pay?.invoice?.totalTaxedPrice || 0)}</span>
                  </div>
                </div>
              </div>

              {/* Payment Details */}
              <div className="p-4 bg-gray-50 shadow-md rounded-lg">
                <h3 className="text-lg text-center font-bold text-gray-700 mb-3 uppercase">Payment info</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Reference:</span>
                    <span>{pay?.reference || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Method:</span>
                    <span>{pay?.method_id || "N/A"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Amount Paid:</span>
                    <span>{formatCurrency(pay?.amount || 0)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Outstanding Balance:</span>
                    <span>{formatCurrency(pay?.invoice?.totalTaxedPrice - pay?.amount || 0)}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Date:</span>
                    <span>{formatMediumDate(pay?.date || "N/A")}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Status:</span>
                    <span
                      className={`uppercase font-bold ${
                        pay?.state === "paid"
                          ? "text-green-600"
                          : pay?.state === "pending"
                          ? "text-yellow-500"
                          : "text-red-500"
                      }`}
                    >
                      {pay?.state || "Pending"}
                    </span>
                  </div>
                </div>
              </div>
            </div>




            {/* Receipt Number Input */}
            <div className="my-4 p-4 bg-gray-50 shadow-md rounded-lg">
              <label className="block text-gray-700 font-bold mb-2">Receipt Number:</label>
              <input
                type="text"
                value={payment.receipt_no}
                onChange={(e) => handlePaymentChange('receipt_no', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:border-blue-400"
              />
            </div>

            {/* Action Buttons */}
<div className="flex justify-end space-x-4 mt-4">
  <button
    onClick={handleSubmit}
    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
  >
    <BsFillSendFill size={20} />
    <span>Submit</span>
  </button>

  <button
    onClick={handleClose}
    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
  >
    <MdOutlineCancel size={20} />
    <span>Close</span>
  </button>
</div>


            
          </div>
        )}
      </div>
    </Layout>
  );
};

export default EnterReceipt;
